import styles from "../DataTable.module.scss";

const newCustomerLabel = () => (
  <span className={`${styles.new_customer_label}`}>
    New!
  </span>
);

export default newCustomerLabel;